module.exports = __webpack_public_path__ + "img/Group74.2357540.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/Group74.png
// module id = /eKP
// module chunks = 1